import { AxiosResponse } from "axios";

import {
  IAddWorflowResponse,
  IHospitalTimezone,
  IWorkflow,
  IWorkflowArticleOption,
  IWorkflowSettings,
  IWorkflowsSelectOption,
  IWorkflowsSurveyOption,
  IWorkflowsTableContentServerResponse,
  IWorkflowTimezoneOption,
  IWorkflowVersion,
} from "../@types/Worflows";
import { api } from "./api";

export const workflowsService = {
  async getAllWorflows(
    hospitalGroupId?: number
  ): Promise<AxiosResponse<IWorkflowsTableContentServerResponse>> {
    const url = "/Portal/Workflows";

    const serverResponse = await api.get(
      url,
      hospitalGroupId ? { params: { hospitalGroupId } } : undefined
    );

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async getWorflowsRuleTypes(
    wardIds?: number[]
  ): Promise<AxiosResponse<IWorkflowsSelectOption[]>> {
    const url = "/Portal/Workflows/GetRuleTypes";

    const serverResponse = await api.post(url, {
      wards: wardIds,
    });

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async getWorflowsRuleConditionComparators(): Promise<
    AxiosResponse<IWorkflowsSelectOption[]>
  > {
    const url = "/Portal/Workflows/GetRuleConditionComparators";

    const serverResponse = await api.get(url);

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async getWorflowsSurveyScoreConditionComparators(): Promise<
    AxiosResponse<IWorkflowsSelectOption[]>
  > {
    const url = "/Portal/Workflows/GetSurveyScoreConditionComparators";

    const serverResponse = await api.get(url);

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async getWorflowsRuleConditionTriggers(): Promise<
    AxiosResponse<IWorkflowsSelectOption[]>
  > {
    const url = "/Portal/Workflows/GetRuleConditionTriggers";

    const serverResponse = await api.get(url);

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async getWorflowsResponseTypes(): Promise<
    AxiosResponse<IWorkflowsSelectOption[]>
  > {
    const url = "/Portal/Workflows/GetResponseTypes";

    const serverResponse = await api.get(url);

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async getWorflowsResponseTimes(): Promise<
    AxiosResponse<IWorkflowsSelectOption[]>
  > {
    const url = "/Portal/Workflows/GetResponseTimes";

    const serverResponse = await api.get(url);

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async getWorflowsActionTypes(): Promise<
    AxiosResponse<IWorkflowsSelectOption[]>
  > {
    const url = "/Portal/Workflows/GetActionTypes";

    const serverResponse = await api.get(url);

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async getWorflowsFibricheckStatuses(): Promise<
    AxiosResponse<IWorkflowsSelectOption[]>
  > {
    const url = "/Portal/Workflows/GetFibricheckStatuses";

    const serverResponse = await api.get(url);

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async getWorflowsAliveCorEcgStatuses(): Promise<
    AxiosResponse<IWorkflowsSelectOption[]>
  > {
    const url = "/Portal/Workflows/GetAliveCorEcgStatuses";

    const serverResponse = await api.get(url);

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async getWorflowsSpirometryStatuses(): Promise<
    AxiosResponse<IWorkflowsSelectOption[]>
  > {
    const url = "/Portal/Workflows/GetSpirometryStatuses";

    const serverResponse = await api.get(url);

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async getWorflowsOccurrencePeriods(): Promise<
    AxiosResponse<IWorkflowsSelectOption[]>
  > {
    const url = "/Portal/Workflows/GetOccurrencePeriods";

    const serverResponse = await api.get(url);

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async getWorflowsSleepStages(): Promise<
    AxiosResponse<IWorkflowsSelectOption[]>
  > {
    const url = "/Portal/Workflows/GetSleepStages";

    const serverResponse = await api.get(url);

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async getWorflowsActivityMetrics(): Promise<
    AxiosResponse<IWorkflowsSelectOption[]>
  > {
    const url = "/Portal/Workflows/GetActivityMetrics";

    const serverResponse = await api.get(url);

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async getWorkflowsDateEventTypes(): Promise<
    AxiosResponse<IWorkflowsSelectOption[]>
  > {
    const url = "/Portal/Workflows/GetDateEventTypes";

    const serverResponse = await api.get(url);

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async getWorflowsArticleOptions(
    wardIds?: number[]
  ): Promise<AxiosResponse<IWorkflowArticleOption[]>> {
    const url = "/Portal/Workflows/GetArticleOptions";

    const serverResponse = await api.post(url, {
      wards: wardIds,
    });

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async getWorflowsSurveyOptions(
    wardIds?: number[]
  ): Promise<AxiosResponse<IWorkflowsSurveyOption[]>> {
    const url = "/Portal/Workflows/GetSurveyOptions";

    const serverResponse = await api.post(url, {
      wards: wardIds,
    });

    if (serverResponse !== undefined) {
      // Remove duplicates based on surveyId if needed
      const uniqueResponses = serverResponse.data.filter(
        (
          option: IWorkflowsSurveyOption,
          index: number,
          self: IWorkflowsSurveyOption[]
        ) =>
          index ===
          self.findIndex(
            (t: IWorkflowsSurveyOption) => t.surveyId === option.surveyId
          )
      );
      serverResponse.data = uniqueResponses;
      return serverResponse;
    }

    throw Error;
  },

  async addWorkflow(
    workflow: IWorkflow
  ): Promise<AxiosResponse<IAddWorflowResponse>> {
    const url = "/Portal/Workflows";

    const serverResponse = await api.post(url, workflow);

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async getWorkflowById(workflowId: string): Promise<AxiosResponse<IWorkflow>> {
    const url = `/Portal/Workflows/${workflowId}`;

    const serverResponse = await api.get(url);

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async updateWorkflow(
    workflowId: string,
    workflowSettings: IWorkflowSettings
  ): Promise<AxiosResponse<IWorkflow>> {
    const url = `/Portal/Workflows/${workflowId}`;

    const serverResponse = await api.put(url, workflowSettings);

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async addWorkflowVersion(
    workflowId: string,
    workflowVersion: IWorkflowVersion
  ): Promise<AxiosResponse<IWorkflow>> {
    const url = `/Portal/Workflows/${workflowId}/Versions`;

    const serverResponse = await api.post(url, workflowVersion);

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async updateWorkflowStatus(
    workflowId: string,
    published: boolean
  ): Promise<AxiosResponse<IWorkflow>> {
    const url = `/Portal/Workflows/${workflowId}/UpdateStatus`;

    const serverResponse = await api.post(url, null, {
      params: {
        published,
      },
    });

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async duplicateWorkflow(
    workflowId: string,
    wards: number[]
  ): Promise<AxiosResponse<IAddWorflowResponse>> {
    const url = `/Portal/Workflows/${workflowId}/Duplicate`;

    const serverResponse = await api.post(url, { wards });

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async getTimezones(): Promise<AxiosResponse<IWorkflowTimezoneOption[]>> {
    const url = "/Portal/Workflows/GetTimezones";

    const serverResponse = await api.get(url);

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async hasPatientsWithCarerEmail(
    wardIds: number[]
  ): Promise<AxiosResponse<boolean>> {
    const params = wardIds.map((id) => `wardIds=${id}`).join("&");
    const url = `/Portal/Workflows/HasPatientsWithCarerEmail?${params}`;

    const serverResponse = await api.get(url);

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async getHospitalTimezone(): Promise<AxiosResponse<IHospitalTimezone>> {
    const url = "/Portal/Workflows/GetHospitalTimezone";

    const serverResponse = await api.get(url);

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },
};
